import React, { useReducer } from 'react';
import { getConfiguration } from './data/utils';
import { isLiveSection } from './Main';

const UISettingsContext = React.createContext({});
const UISettingsDispatch = React.createContext(null);

export function useUISettings() {
    return React.useContext(UISettingsContext);
}

export function useUISettingsDispatch() {
    return React.useContext(UISettingsDispatch);
}

const LayoutContext = React.createContext({});
const LayoutDispatch = React.createContext(null);

export function useLayout() {
    return React.useContext(LayoutContext);
}

export function useLayoutDispatch() {
    return React.useContext(LayoutDispatch);
}

const layoutMap = {
    'sb-1': {
        sidebarSx: 'ord-3',
        divCentrale: 'ord-2',
        sidebarDx: 'ord-1'
    },
    'sb-2': {
        sidebarSx: 'ord-1',
        divCentrale: 'ord-2',
        sidebarDx: 'ord-3'
    },
    'sb-3': {
        sidebarSx: 'ord-1',
        divCentrale: 'ord-3',
        sidebarDx: 'ord-2'
    },
};

function uiSettingsReducer(state, action) {
    switch (action.type) {
        case 'setFullscreen': {
            if (action.isFullScreen) {
                document.body.classList.add('e-largo-centro');
            } else {
                document.body.classList.remove('e-largo-centro');
            }
            return {
                ...state,
                fullScreen: action.isFullScreen
            };
        }
        case 'toggleFullscreen': {
            if (!state.fullScreen) {
                document.body.classList.add('e-largo-centro');
            } else {
                document.body.classList.remove('e-largo-centro');
            }
            return {
                ...state,
                fullScreen: !state.fullScreen
            };
        }
        default:
            throw new Error();
    }
}

function layoutReducer(state, action) {
    switch (action.type) {
        case 'setLayout': {
            return {
                ...state,
                type: action.layout,
                order: layoutMap[action.layout]
            };
        }
        default:
            throw new Error();
    }
}

export default function UISettingsProvider(props) {
    const [uiSettingsState, uiSettingsDispatch] = useReducer(uiSettingsReducer, {
        //fullScreen: conf && conf.tfs && conf.tfs === true,
        fullScreen: false,
    });

    const [layoutState, layoutDispatch] = useReducer(layoutReducer, {
        type: 'sb-2',
        order: layoutMap['sb-2'],
    });

    if (isLiveSection(props.section)) {
        const conf = getConfiguration();
        if (uiSettingsState.fullScreen && !conf.tfs) {
            uiSettingsDispatch({type: 'toggleFullscreen'});
        }
    }

    return (
        <UISettingsContext.Provider value={uiSettingsState}>
            <UISettingsDispatch.Provider value={uiSettingsDispatch}>
                <LayoutContext.Provider value={layoutState}>
                    <LayoutDispatch.Provider value={layoutDispatch}>
                        {props.children}
                    </LayoutDispatch.Provider>
                </LayoutContext.Provider>
            </UISettingsDispatch.Provider>
        </UISettingsContext.Provider>
    );
}
